import * as React from 'react'
import { Callout, ICalloutProps } from '@blueprintjs/core'
import Icon from './FAIcon'
import css from './callout.module.scss'

interface CalloutWithFAIconProps {
  faIcon: string | null | undefined
}

export default function CalloutWithFAIcon({
  faIcon,
  ...props
}: CalloutWithFAIconProps & ICalloutProps) {
  let iconEl

  if (faIcon) {
    iconEl = (
      <div className={css.icon_wrapper}>
        <Icon name={faIcon} />
      </div>
    )
  }
  return <Callout icon={iconEl} {...props} />
}
